import store from '@/store'
import config from '@/config'
import Gtm from '@/components/mixins/Gtm'
import Branding from '@/components/mixins/Branding'
import lib from '@/library'

export default {
  mixins: [
    Gtm,
    Branding
  ],
  computed: {
    liveEvents () {
      var liveEvents = store.getters['livebettingState/liveEvents']
      return liveEvents && liveEvents.filter(ev => !ev.isawaitingstart)
    },
    liveEventsLoaded () {
      return store.getters['livebettingState/liveEventsLoaded']
    },
    boNavigation () {
      return store.getters['bonavigationState/boNavigation']
    },

    idfwbonavigation1 () {
      return this.$route.params.idfwbonavigation1
    },
    idfwbonavigation2 () {
      return this.$route.params.idfwbonavigation2
    },

    dateFormats () {
      // get override by brand if exists
      var dateFormats = config.app.dateFormats
      var brandingOverrides = dateFormats && dateFormats.overrides && dateFormats.overrides[this.brandKey]
      if (brandingOverrides) {
        for (let key in brandingOverrides) {
          dateFormats[key] = brandingOverrides[key]
        }
      }
      return dateFormats
    },
    isDebug () {
      return this.$route.query.debug || store.getters['getDebugLevel']
    }
  },

  methods: {
    goToEvent (event, module, parlays, popularParlaysType, popularParlaysIDFWMarketGroup) {
      if (this.$route.params.idfoevent === event.idfoevent) return

      store.dispatch('overlayState/deactivatePopularParlaysDialogData', false)
      const originOfParlay = parlays ? lib.personalization.popularParlays.getOrigin(parlays) : ''
      var idfosporttype = event.idfosporttype || (event.markets && event.markets[0] && event.markets[0].idfosporttype) || undefined
      const origin = originOfParlay === 'MM' ? 'MM' : 'Vaix'
      if (store.getters['recommendedState/getRecommendedEventsTabActive']) {
        this.sendGTMGoToEventPage(event.idfoevent, event.eventname, this.couponname, event.fosportname || event.sportname || event.idfosport, idfosporttype, this.isLiveEvent(event.idfoevent), origin, popularParlaysType, popularParlaysIDFWMarketGroup)
      } else {
        this.sendGTMGoToEventPage(event.idfoevent, event.eventname, this.couponname, event.fosportname || event.sportname || event.idfosport, idfosporttype, this.isLiveEvent(event.idfoevent), originOfParlay, popularParlaysType, popularParlaysIDFWMarketGroup, this.$route.name)
      }
      store.commit('recommendedState/setRecommendedEventsTabActive', false)

      if (event.idfoevent) {
        if (['search', 'searchsport', 'searchcompetition'].indexOf(this.$route.name) > -1) {
          this.$router.push({ name: 'event', params: { idfoevent: event.idfoevent }, query: { search: 'true' } })
        } else {
          this.$router.push({ name: 'event', params: { idfoevent: event.idfoevent } })
        }
      }
    },
    checkIsNodeNavigationType (node, navigationType) {
      if (node && node.idfwbonavigationtypes) {
        return node.idfwbonavigationtypes.filter(item => item === navigationType).length > 0
      }

      return false
    },
    isDateToday (date) {
      // do not display TODAY/TOMORROW for selected brands
      if (['circa'].indexOf(this.brandKey) === -1 && date) {
        var arrDateAndTime = date && date.toString().split('T')
        var arrDate = arrDateAndTime && Array.isArray(arrDateAndTime) ? arrDateAndTime[0].split('-') : arrDateAndTime.split('-')
        if (arrDate && arrDate.length === 3) {
          try {
            let year = arrDate[0] && parseInt(arrDate[0])
            let month = arrDate[1] && parseInt(arrDate[1])
            let day = arrDate[2] && parseInt(arrDate[2])
            let today = new Date()
            if (year === today.getFullYear() && month === (today.getMonth() + 1) && day === today.getDate()) {
              return true
            }
          } catch (e) {
            console.log(`isDateToday - Could not parse the date (${date}): [${e.message}]`)
            return false
          }
        }
      }
      return false
    },
    isDateTomorrow (date) {
      // do not display TODAY/TOMORROW for selected brands
      if (['circa'].indexOf(this.brandKey) === -1 && date) {
        var arrDateAndTime = date && date.toString().split('T')
        var arrDate = arrDateAndTime && Array.isArray(arrDateAndTime) ? arrDateAndTime[0].split('-') : arrDateAndTime.split('-')
        if (arrDate.length === 3) {
          try {
            let year = arrDate[0] && parseInt(arrDate[0])
            let month = arrDate[1] && parseInt(arrDate[1])
            let day = arrDate[2] && parseInt(arrDate[2])
            let today = new Date()
            let tomorrow = new Date(today)
            tomorrow.setDate(today.getDate() + 1)
            if (year === tomorrow.getFullYear() && month === (tomorrow.getMonth() + 1) && day === tomorrow.getDate()) {
              return true
            }
          } catch (e) {
            console.log(`isDateTomorrow - Could not parse the date (${date}): [${e.message}]`)
            return false
          }
        }
      }
      return false
    },
    isLiveEvent (idfoevent) {
      return this.liveEvents && this.liveEvents.filter(ev => ev.idfoevent === idfoevent).length > 0
    },
    isPlayerPropsMarket (market) {
      return config.app.autoconf.GROUP_PLAYER_PROPS_MARKETS &&
             market &&
             market.idfomarketlinetype === 'PLPROPS' &&
             market.idfohadtype === 'OU' &&
             market.name.includes(' - ') &&
             market.selections &&
             market.selections.length === 2
    },
    addToBetslip (selections, module, popularParlaysType, popularParlaysIDFWMarketGroup) {
      store.dispatch('overlayState/deactivatePopularParlaysDialogData', false)
      const originOfParlay = selections ? lib.personalization.popularParlays.getOrigin(selections) : ''
      if (selections) {
        let deactivateDialogTo = null
        store.dispatch('overlayState/activateAddingSelectionDialog')
        deactivateDialogTo = setTimeout(() => {
          store.dispatch('overlayState/deactivateAddingSelectionDialog')
        }, 1000)
        let currentBetSlipState = store.getters['sbBetslipState/currentBetSlipState']
        if (currentBetSlipState < 1 && selections.length) {
          clearTimeout(deactivateDialogTo)
          setTimeout(function () {
            store.dispatch('sbBetslipState/injectXSelections', {selections, originOfParlay, popularParlaysIDFWMarketGroup})
              .finally(() => {
                store.dispatch('overlayState/deactivateAddingSelectionDialog')
              })
          }, 10)
        } else {
          // console.log('PopularParlay not added; currentBetSlipState:', currentBetSlipState, '; selections.length:', selections.length)
          let reason = currentBetSlipState > 0 ? 'NOT_IDLE' : 'INVALID_PARLAY'
          clearTimeout(deactivateDialogTo)
          setTimeout(function () {
            store.dispatch('overlayState/deactivateAddingSelectionDialog')
              .finally(() => {
                setTimeout(function () {
                  store.dispatch('overlayState/activateBetslipMsg', [reason])
                }, 200)
              })
          }, 500)
        }
      }
      this.sendPopulaParlaysGTMAddToBetslip(selections, originOfParlay, module, popularParlaysType, popularParlaysIDFWMarketGroup, this.$route.name)
    },
    sortedEventData (selectionData) {
      // Group the data by IDFOEvent
      const groupedData = {}
      selectionData.forEach(item => {
        const eventId = item.market.idfoevent
        if (!groupedData[eventId]) {
          groupedData[eventId] = []
        }
        groupedData[eventId].push(item)
      })
      // Sort the grouped data by IDFOEvent
      const sortedEventData = {}
      Object.keys(groupedData)
        .sort((a, b) => groupedData[b].length - groupedData[a].length) // Sort event IDs numerically
        .forEach(key => {
          sortedEventData[key] = groupedData[key]
        })
      return sortedEventData
    },
    getPriceByIdfoSelection (parlay, idfoselection) {
      let price = null
      parlay.BetCalculation.ProviderCalculation.forEach(providerCalc => {
        providerCalc.Bets.forEach(bet => {
          if (bet.Key.includes(idfoselection.toString())) {
            price = parseFloat(bet.Price)
          }
        })
      })
      return price
    },
    isAmericanSport (sport) {
      const americanSports = ['NFL', 'ICE HOCKEY', 'BASKETBALL', 'BASEBALL']
      if (americanSports.includes(sport.idfosporttype)) return sport && (sport.participantshortname_away && sport.participantshortname_home) ? sport.participantshortname_away + ' @ ' + sport.participantshortname_home : sport.eventname
      return sport.eventname
    },
    numberOfSGP (selections) {
      const idfoeventCounts = {}
      selections.forEach(item => {
        const idfoevent = item.market.idfoevent
        if (idfoeventCounts[idfoevent]) {
          idfoeventCounts[idfoevent]++
        } else {
          idfoeventCounts[idfoevent] = 1
        }
      })
      let moreThanOne = 0
      let onlyOne = 0
      for (const idfoevent in idfoeventCounts) {
        if (idfoeventCounts[idfoevent] > 1) {
          moreThanOne++
        } else {
          onlyOne++
        }
      }
      return { moreThanOne, onlyOne }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/BettingOffer.js